import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    alertShown: false,
};

const alertSlice = createSlice ({
    name:'alert',
    initialState,
    reducers:{
        showAlert(state){
            state.alertShown = true;
        },
        resetAlert(state) {
            state.alertShown = false;
        },
    },
});

export const {showAlert, resetAlert} = alertSlice.actions;

export default alertSlice.reducer;